/*
index.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

export interface SpinnerProps {
size: number
text: string
}
export const Spinner = (props:SpinnerProps) =>{
    return <div>
    <div className={`justify-content-center align-items-center xrx-activity-indicator-round row mx-0 size-${props.size} mb-3`}>
  <div className="xrx-activity-indicator-center"></div>
</div>
  <div className="row mx-0 xrx-activity-indicator-label justify-content-center">
    <span className="text-center">
        {props.text}
    </span>
  </div>
</div>
}